module.exports = __webpack_public_path__ + "media/your_career_track/career_profiles_sprite-a01e8cd7.png";